/**
 * Orden de modelos iPhone: generación más nueva primero,
 * y dentro de cada generación Pro Max > Pro > Plus > base.
 */
const TIER_RANK = {
  'pro max': 0,
  promax: 0,
  pro: 1,
  plus: 2,
  '': 3,
};

function normalizeModelo(modelo) {
  return String(modelo || '')
    .toLowerCase()
    .replace(/iphone/g, ' ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

function parseModeloRank(modelo) {
  const normalized = normalizeModelo(modelo);
  const genMatch = normalized.match(/(\d{1,2})/);
  const generation = genMatch ? Number(genMatch[1]) : 0;

  let tier = 3;
  if (/\bpro\s*max\b/.test(normalized) || normalized.includes('promax')) {
    tier = TIER_RANK['pro max'];
  } else if (/\bpro\b/.test(normalized)) {
    tier = TIER_RANK.pro;
  } else if (/\bplus\b/.test(normalized)) {
    tier = TIER_RANK.plus;
  }

  return {
    generation,
    tier,
    normalized,
  };
}

export function compareModelos(a, b) {
  const rankA = parseModeloRank(a);
  const rankB = parseModeloRank(b);

  if (rankA.generation !== rankB.generation) {
    return rankB.generation - rankA.generation;
  }
  if (rankA.tier !== rankB.tier) {
    return rankA.tier - rankB.tier;
  }
  return rankA.normalized.localeCompare(rankB.normalized);
}

export function sortModelos(modelos) {
  return [...modelos].sort(compareModelos);
}

export function compareProductosPorModelo(a, b, getTitulo) {
  const modeloCmp = compareModelos(a?.modelo, b?.modelo);
  if (modeloCmp !== 0) {
    return modeloCmp;
  }
  if (typeof getTitulo === 'function') {
    return String(getTitulo(a) || '').localeCompare(String(getTitulo(b) || ''));
  }
  return String(a?.nombre || '').localeCompare(String(b?.nombre || ''));
}
